const ACTION_ITEMS = {
  CANDIDATE_VERIFY: {
    INFO: {
      SET: 'CANDIDATE_VERIFY_INFO_SET',
    },
  },
};

export default ACTION_ITEMS;
